import React from 'react';

const Gallery = () => {
  const galleryImages = [
    {
      src: "images/img-3.jpeg",
      caption: "Warm white C9 Christmas lights installation – Barrie"
    },
    {
      src: "images/img-4.jpeg", 
      caption: "Commercial holiday lighting – Collingwood plaza"
    },
    {
      src: "images/img-6.jpeg",
      caption: "Residential Christmas display – Orillia"
    },
    {
      src: "images/img-7.jpeg",
      caption: "Tree lighting installation – Innisfil"
    },
    {
      src: "images/img-5.jpeg",
      caption: "Multi-color LED display – Wasaga Beach"
    },
    {
      src: "images/img-9.jpeg",
      caption: "Professional roofline lighting – Midland"
    }
  ];

  return (
    <section className="py-8 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2 className="dest_heading mb-12">Our Christmas Light Installations</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryImages.map((image, index) => (
            <div key={index} className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300">
              <img 
                src={image.src} 
                alt={image.caption}
                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white text-sm font-medium">{image.caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;